import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import {
  type GroupEdgeSettings,
  type TopologyGraphEdgeSettings,
  isTopologyEdgeSettings,
} from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface DeleteEdgeGroupCommand {
  groupId: GroupEdgeSettings['id'];
}

export const deleteEdgeGroup: GraphCommandFactory<DeleteEdgeGroupCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const { presetDraft } = draft.layoutSettings;
      const foundGroup = presetDraft.edges.find(
        (item: TopologyGraphEdgeSettings): item is GroupEdgeSettings =>
          item.id === command.groupId && item.type === 'group',
      );
      if (foundGroup) {
        const removedProtocols = foundGroup.children;
        for (const protocol of removedProtocols) {
          if (isTopologyEdgeSettings(protocol)) {
            presetDraft.edges.push(protocol);
          } else {
            stumble('Non topology protocol found in topology group');
          }
        }
        const foundGroupIndex = presetDraft.edges.findIndex(
          (group) => group.id === command.groupId,
        );
        presetDraft.edges.splice(foundGroupIndex, 1);
      }
    });
  };
